module.exports = __webpack_public_path__ + "img/4800.a2fe71b4.jpg";